<template>
  <div class="userCenter">
    <div class="boxCenter">
      <div class="userBox">
        <LeftSide></LeftSide>
        <div class="userRight">
          <div class="userTitle">积分记录 <span class="total-score">总计：<span style="color: red">{{userData.points}}</span> 分</span></div>
          <div class="scoreBox">
            <el-table :data="tableData" border  style="width: 100%">
              <el-table-column prop="oppDatetime" label="操作时间">
                <template slot-scope="scope">
                  <span>{{scope.row.oppDatetime.substring(0,19)}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="remark" label="备注信息"></el-table-column>
              <el-table-column prop="oppPoints" label="操作分数"></el-table-column>
              <el-table-column prop="currentPoints" label="操作后积分"></el-table-column>
            </el-table>
            <div style="padding:50px;text-align: center">
              <el-pagination
                background
                layout="prev, pager, next"
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-size="10"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LeftSide from './common/leftside'
  import eventVue from '../bus.js'
  export default {
    components: {
      LeftSide
    },
    data(){
      return {
        //userId:9,
        tableData: [],
        pageIndex:1,
        total:0,
        totalScore:0,
      }
    },
    computed: {
      userData() {
        return this.$store.state.userData
      }
    },
    watch: {
      userData: {
        handler(newName, oldName){
          if (newName) {
            this.loadData()
          }
        },
        immediate: true
      }
    },
    created(){
      //this.loadData()
      
    },
    mounted(){
      eventVue.$emit("leftSwitch",'4')
    },
    methods:{
      loadData(){
        this.$https.get('/api/point/pageIndex/'+this.pageIndex+'/pageNum/10?memberId='+this.userData.id).then((res)=>{
          this.tableData = res.data.records
          this.total = res.data.total
        }).catch((error) => {

        });
      },
      handleCurrentChange(val){
        this.pageIndex = val
        this.loadData()
      },
    }
  }
</script>

<style scoped>
  .scoreBox{
    padding: 20px;
  }
  .total-score{
    float: right;
    font-size: 14px;
    margin-right: 30px;
    font-weight: normal;
  }
  .editBtn{
    position: absolute;
    color: #5680f9;
    right: 20px;
    top: 14px;
    font-size: 16px;
    cursor: pointer;
  }
  .editBox{
    padding:27px 0 0 193px;
    overflow: hidden;
  }
  .editBox span{
    float: left;
    width: 96px;
    text-align: center;
    height: 38px;
    line-height: 38px;
    border: 1px solid #E5E5E5;
    border-radius: 4px;
    font-size: 14px;
    color: #919191;
    margin-right: 20px;
    cursor: pointer;
  } 
  .editBox .save{
    color: #ffffff;
    background: #FFCD30;
    border: 1px solid #FFCD30;
  }
</style>



// WEBPACK FOOTER //
// src/components/score.vue